import { render } from "./uploadFile.vue?vue&type=template&id=79469074&scoped=true"
import script from "./uploadFile.vue?vue&type=script&lang=js"
export * from "./uploadFile.vue?vue&type=script&lang=js"

import "./uploadFile.vue?vue&type=style&index=0&id=79469074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79469074"]])

export default __exports__